import React from "react";
import "./../componts/styles.css";
import img from "./../imgs/1.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";
import a from "./../../home/imgs/gallery/2.jpeg";
import b from "./../../home/imgs/gallery/3.jpeg";
import c  from "./../../home/imgs/gallery/4.png";
import d  from "./../../home/imgs/gallery/5.jpg";
import e  from "./../../home/imgs/gallery/6.jpg";
import f  from "./../../home/imgs/gallery/me2.jpg";
import g from "./../../home/imgs/gallery/15.jpeg";
import h  from "./../../home/imgs/gallery/WhatsApp Image 2024-08-30 at 12.13.07.jpeg";
import i  from "./../../home/imgs/gallery/WhatsApp Image 2024-10-08 at 20.26.36.jpeg";
import j  from "./../../home/imgs/gallery/WhatsApp Image 2024-10-12 at 21.55.54.jpeg";
import l from "./../../home/imgs/gallery/WhatsApp Image 2024-10-12 at 21.55.54 (1).jpeg";
import m from "./../../home/imgs/gallery/WhatsApp Image 2024-10-12 at 21.55.53.jpeg";
import n from "./../../home/imgs/gallery/WhatsApp Image 2024-10-08 at 20.30.12.jpeg";
import o from "./../../home/imgs/gallery/WhatsApp Image 2024-10-08 at 20.26.38 (1).jpeg";
import logo from "./../../home/imgs/Logo.png";

// import Swiper core and required modules
import {
  Navigation,
  EffectCoverflow,
  Pagination,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./../../../App.css";

import { Swiper, SwiperSlide } from "swiper/react";




export default function Gallery() {
  return (
    <>
      <div className="gallerytopbg"></div>
      <div className="mb-20">
        <h1 className="text-3xl font-bold  my-8 text-customBlue  text-center">
          <span className="ms-2 text-[#3A636C]">Gallery</span>
        </h1>
        <h4 className="mt-[-30px] text-center">
          You wanna know normally Who we are?!{" "}
        </h4>
      </div>
      <div className="mx-auto p-8">
        <div className="">
          <Swiper
            // Coverflow effect with rotation and depth
            // effect={"coverflow"}
            grabCursor={true} // Makes the cursor look like a hand
            centeredSlides={true} // Centers the slides
            slidesPerView={3} // Display 3 slides at once
            // coverflowEffect={{
            //   rotate: 160, // How much to rotate the slides
            //   stretch: 120, // Space between slides
            //   depth: 250, // How deep the slides go
            //   modifier: 2, // Multiplies the effects
            //   slideShadows: true, // Adds shadows behind slides
            // }}
            autoplay={{
              // Autoplay settings
              delay: 1000, // Delay before switching to the next slide
              disableOnInteraction: false, // Keeps autoplay even when the user interacts with the slider
            }}
            pagination={{ clickable: true }} // Allows pagination dots to be clickable
            navigation={true} // Adds next/previous navigation arrows
            modules={[Navigation, Pagination, EffectCoverflow, Autoplay]} // Include the modules you want to use
            className="customSwiper h-[500px]"
            loop={true} // Loops through slides infinitely
            breakpoints={{
              // When window width is >= 768px
              768: {
                slidesPerView: 3, // 3 slides per view for larger screens
              },
              // When window width is < 768px
              0: {
                slidesPerView: 1, // 1 slide per view for small screens
              },
            }}
          >
            {/* SwiperSlide 1 - Example of an image */}
            <SwiperSlide>
              <div>
                <img src={img} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={j} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={a} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img src={b} alt="grandshopGallery" />
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="mainContainer mx-auto p-2 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4">
            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={c}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={e}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={g}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={j}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={l}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={i}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={d}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={f}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={h}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={m}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={n}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}

            {/* start of image  */}
            <div className="imgcontainer relative">
              <img
                src={o}
                alt="Avatar"
                className="LightBoxImage w-full h-auto"
              />
              <div className="overlay absolute inset-0 flex flex-col bg-black bg-opacity-50">
                <img src={logo} className="w-32" alt="grandshoplogo" />
                <div className="text text-white text-lg">Grand Shop Rwanda</div>
              </div>
            </div>
            {/* end of image  */}
          </div>
        </div>
      </div>
    </>
  );
}
